export default __webpack_public_path__ + "54fdef90324c9a8b379a151a2d714ff4.svg";